import React from "react";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { usePerson, useUpdatePerson } from "../../../services/customersService";
import BasicDialog from "../../base/BasicDialog";
import { SnackbarError } from "../../base/SnackbarAlert/SnackbarError";
import { SnackbarSuccess } from "../../base/SnackbarAlert/SnackbarSuccess";
import { PersonDetailsForm } from "./PersonDetailsForm";
import LoaderWrapper from "../../wrapper/LoaderWrapper";

// TODO are there reusable pesel/nip inputs
export const PersonDetailsDialog = (props) => {
    const { open, onClose, personId } = props;
    const { t } = useTranslation();
    const { data: person, isLoading } = usePerson(personId);
    const { mutate: updatePerson, isPending } = useUpdatePerson({
        onSuccess: () => {
            toast.custom(
                (curToast) => (
                    <SnackbarSuccess message={t("customers.PersonDetailsDialog.success")} />
                ),
                {
                    position: "bottom-right",
                },
            );
            onClose()
        },
        onError: (error) => {
            console.error("Error updating person:", error);
            toast.custom(
                () => <SnackbarError message={t("customers.PersonDetailsDialog.error")} />,
                {
                    position: "bottom-right",
                },
            );
        },
    });

    const initialValues = {
        person_name: person?.name ?? "",
        person_name2: person?.name2 ?? "",
        person_surname: person?.surname ?? "",
        person_name_of_father: person?.name_of_father ?? "",
        person_name_of_mother: person?.name_of_mother ?? "",
        person_maiden_surname: person?.maiden_surname ?? "",
        person_marital_status: person?.marital_status ?? "",
        person_financial_status: person?.financial_status ?? "",
        person_pesel: person?.pesel ?? "",
        person_citizenship: person?.person_citizenship ?? "",
    };

    const handleSubmit = (data) => {
        // const onlyNonEmptyData = {};
        // Object.entries(data).forEach(([key, value]) => {
        //     if (value !== "" && value !== null && value !== undefined) {
        //         onlyNonEmptyData[key] = value;
        //     }
        // });
        updatePerson({ id: personId, body: data });
    };

    return (
        <BasicDialog
            open={open}
            onClose={onClose}
            titleAlign={"center"}
            contentAlign={"center"}
            title={t("customers.PersonDetailsDialog.title")}
            minWidth={800}
            maxWidth={"xl"}
            showDialogActions
        ><LoaderWrapper showLoader={isLoading}>
            {<PersonDetailsForm
                defaultValues={initialValues}
                disabled={isPending || isLoading}
                loading={isPending}
                onSubmit={handleSubmit}
            />}
            </LoaderWrapper>
        </BasicDialog>
    );
};
